import { GuaranteeStatus } from '../models/guarantee-constants';
import { TranslationService } from '../../shared/services/translation.service';

export function getGuaranteeRequestStatusTr(translationService: TranslationService, status: GuaranteeStatus) {
	switch (status) {
	case GuaranteeStatus.OPEN:
		return translationService.getTR('global.open');
	case GuaranteeStatus.SATISFIED:
		return translationService.getTR('guarantee.satisfied');
	case GuaranteeStatus.LAUNCH_ANALYSIS:
		return translationService.getTR('issue.inprocess');
	case GuaranteeStatus.CERTIFICATE_REQUESTED:
		return translationService.getTR('guarantee.certificate.requested');
	case GuaranteeStatus.CERTIFICATE_ISSUED:
		return translationService.getTR('guarantee.certificate.issued');
	case GuaranteeStatus.REJECTED_BY_SUPLIER:
		return translationService.getTR('guarantee.supplier.rejected');
	case GuaranteeStatus.DRAFT:
		return translationService.getTR('guarantee.draft');
	case GuaranteeStatus.CANCELLED:
		return translationService.getTR('guarantee.cancelled');
	default:
		return translationService.getTR('guarantee.unknown');
	}
}
